<template>
    <section>
        <SideBar />
        <TopBar />
        <div class="content">
            <div class="reduced-fit">
                <div class="main-content-header">
                    <h1>Propietarios</h1>
                </div>
                <LoadingContent v-if="isLoading" />
                <div class="row w-65">
                    <div class="col-lg-12 ">
                        <div class="card mb-30" >
                            <div class="card-content" >
                                <div class="card-body">
                                    <div class="card-header" >
                                        <h5 class="card-title">{{ titulo }}</h5>
                                    </div>
                                    <div class="row">
                                        <div class="col-10">
                                            <form>
                                                <div class="row ">
                                                    <label class="col-2 text-nowrap">Clave</label>
                                                    <div class="col-5"> 
                                                        <input ref="clave" type="text" maxlength="15" class="form-control form-control-sm" :disabled="modo == 'Modificando'" required v-model="propietario.clave" />													
                                                    </div>
                                                </div>	
                                                <div class="row ">
                                                    <label class="col-2 text-nowrap">Nombre</label>
                                                    <div class="col-10">
                                                        <input ref="nombre" maxlength="254" type="text" class="form-control form-control-sm" v-model="propietario.nombre" />													
                                                    </div>
                                                </div>	
                                                <div class="row ">
                                                    <label class="col-2 text-nowrap">RFC</label>
                                                    <div class="col-6">
                                                        <input ref="rfc" maxlength="15" type="text" class="form-control form-control-sm" v-model="propietario.rfc" />
                                                    </div>
                                                </div>	
                                                <div class="row">
                                                    <label class="col-2 text-nowrap text-right">País</label>
                                                    <div class="col-10">
                                                        <select class="form-control form-control-sm" v-model="propietario.pais">
                                                            <option value=""></option>
                                                            <option v-for="(clave, key) in clavespaises" :key="key" :value="key">{{clave}}</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div class="row ">
                                                    <label class="col-2 text-nowrap">NumRegIdTrib</label>
                                                    <div class="col-5">
                                                        <input ref="regidtrib" maxlength="20" type="text" class="form-control form-control-sm" v-model="propietario.regidtrib" />
                                                    </div>
                                                </div>	
                                            </form>
                                        </div>
                                        <div class="col-2">
                                            <ul class="d-block p-1 list-unstyled controls-form">
                                                <li><button @click="setPropietario()" class="btn btn-sm btn-success btn-block">Aceptar</button></li>
                                                <li><router-link to="/propietarios" class="btn btn-sm btn-danger btn-block">Salir</router-link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import handleForm from '@/mixins/handleForm';
import LoadingContent from '@/components/LoadingSpinner.vue'
import handleGlobals from '@/mixins/handleGlobals'

import SideBar from '@/components/SideBarNav.vue';
import TopBar from '@/components/TopBarNav.vue';
export default {
    components:{SideBar, TopBar,LoadingContent },
    mixins:[handleForm,handleGlobals],
    data(){
        return{
            id: this.$route.params.propietario,
            modo: (this.$route.params.propietario > 0 ? 'Modificando' : 'Creacion'), 
            propietario: [],
            titulo: 'Agregando un Propietario',
            clavespaises:[]
        }
    },
    mounted(){
        this.Get_SAT_ClavesPaises()
        this.llenaForma();
    },
    methods:{
        Get_SAT_ClavesPaises(){
            fetch(this.$api+'/rdx', {
                method: "POST",
                headers: { "Content-Type": "application/json",
                            'Authorization' : this.$store.state.iasctratkn },
                body: JSON.stringify({ accion: "metodo", 
                                        archivo: "Global", 
                                        metodo: "Get_SAT_ClavesPaises",
                                        params: {}
                                       })
            }).then((response)=>{
                if(response.ok){
                    return response.json();
                }   
            }).then((data)=>{
                this.clavespaises = data
            }).catch((err)=>{
                this.falseToken(err)
            });
        },       
        async llenaForma(){
            await this.getPropietario();
            this.titulo = this.$route.params.propietario > 0 ? 'Cambiando un Propietario' :  'Agregando un Propietario'
        },
        getPropietario(){
            let req = []
            this.isLoading = true
             fetch(this.$api+'/rdx', {
                method: "POST",
                headers: { "Content-Type": "application/json",
                            'Authorization' : this.$store.state.iasctratkn },
                body: JSON.stringify({ accion: "inicializar", modo:this.modo, archivo: "Propietarios", id: this.id })
            }).then((response)=>{
                if(response.ok){
                    return response.json()
                }   
            }).then((data)=>{
                this.propietario = data['res']
                req = data['req']
            }).finally(()=>{
                this.setRequired(req)
                this.isLoading = false
            }).catch((err)=>{
                this.falseToken(err)
            });
        },
        setPropietario(){
            fetch(this.$api+'/rdx', {
                method: "POST",
                headers: { "Content-Type": "application/json",
                            'Authorization' : this.$store.state.iasctratkn },
                body: JSON.stringify({  accion: 'validar', archivo: "Propietarios", modo:this.modo, record: this.propietario }) 
            }).then((response)=>{
                if(response.ok){
                    return response.json();
                }   
            }).then((data)=>{
                if(data['res'] == 'error'){
                    this.showNotification = true
                    this.notificationTitle =  'Error'
                    this.notificationText = data['msg']
                    this.notificationRef = 'clave'
                }else{
                    this.$router.push('/propietarios')
                }
            }).catch((err)=>{
                this.falseToken(err)
            });
        },
        afterClose(){
            this.$refs[this.notificationRef].focus()
        }
    }
}
</script>